import { faSearch } from '@fortawesome/pro-light-svg-icons/faSearch'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import Input from '@qc/particle/lib/components/input'
import React from 'react'

export interface Props {
  onChange: (arg0: any) => void
  value: string
  placeholder?: string
  size?: 'small' | 'middle' | 'large'
  containerStyle?: React.CSSProperties
}

const SearchBox = ({ onChange, value, placeholder, size, containerStyle }: Props) => (
  <Input
    size={size}
    placeholder={placeholder}
    value={value}
    onChange={onChange}
    allowClear={true}
    prefix={<FontAwesomeIcon icon={faSearch} />}
    style={{ paddingBottom: '8px', ...containerStyle }}
  />
)

export default SearchBox
